<template>
  <b-modal
    id="service-system-assign-operator-modal"
    cancel-variant="outline-secondary"
    :ok-title="$t('chat.assign')"
    :cancel-title="$t('button.close')"
    centered
    no-close-on-backdrop
    :title="$t('general.assignServiceSystemTo')"
    :ok-disabled="data.assignedOperatorId === initialOperatorId"
    @ok="handleOk"
  >
    <validation-observer
      ref="assignOperatorForm"
      #default="{ invalid }"
    >
      <!-- form -->
      <n-form-confirmation
        ref="formConfirmation"
        key="assignOperatorForm"
        :message="
          $t('general.serviceAssignAndNotify', { operator: operatorName })
        "
        :confirm-button-text="`button.confirm`"
        :cancel-button-text="`button.no`"
        :form="$refs.assignOperatorForm"
        :disabled="invalid"
        @submit="submit"
      >
        <label class="d-block">
          {{ $t('field.operator') }}
        </label>
        <n-async-single-select
          key="merchantUserId"
          v-model="data.assignedOperatorId"
          repository="operator"
          selection-key="id"
          selection-label="name"
          rules="required"
          :query="{
            departmentId: data.departmentId,
            isActive: true,
          }"
          :get-option-label="getLabel"
          :init-options="data.assignedOperatorId"
          @optionChange="onChangeOperator"
        />
      </n-form-confirmation>
    </validation-observer>

    <template #modal-ok>
      <b-spinner
        v-if="loading"
        small
        label="Spinning"
      />
      <span v-else>
        {{ $t('chat.assign') }}
      </span>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BSpinner } from 'bootstrap-vue'
import Repository from '@/repositories/RepositoryFactory'
import NFormConfirmation from '@/components/NFormConfirmation.vue'
import NAsyncSingleSelect from '@/components/NAsyncSingleSelect.vue'
import useJwt from '@/auth/jwt/useJwt'
import FormInput from './assignOperatorFormInput'

const ServiceSystemRepository = Repository.get('serviceSystem')

export default {
  components: {
    BModal,
    BSpinner,
    NFormConfirmation,
    NAsyncSingleSelect,
  },
  props: {
    activeChannel: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      loading: false,
      data: {
        assignedOperatorId: '',
        serviceSystemId: '',
        departmentId: '',
      },
      initOperatorId: '',
      operatorName: '',
      key: 1,
      initialOperatorId: null, // Add this to track initial value
    }
  },
  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
          localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName),
        )
    },
  },
  // watch: {
  //   'data.assignedOperatorId': {
  //     handler() {
  //       if (this.data.assignedOperatorId === this.userData.id) {
  //         this.data.assignedOperatorId = ''
  //       }
  //     },
  //     deep: true,
  //     immediate: true,
  //   },
  // },
  methods: {
    getLabel(option) {
      return option.name || ''
    },
    show(serviceSystem) {
      this.key += 1
      this.data = {
        serviceSystemId: serviceSystem.id,
        assignedOperatorId: serviceSystem.assignedOperatorId,
        departmentId: serviceSystem.departmentId,
      }
      this.initOperatorId = serviceSystem.assignedOperatorId // Store initial value
      this.operatorName = serviceSystem.assignedOperator
      this.initialOperatorId = serviceSystem.assignedOperatorId // Store initial value
      this.$bvModal.show('service-system-assign-operator-modal')
    },
    hide() {
      this.data = {}
      this.$bvModal.hide('service-system-assign-operator-modal')
    },
    onChangeOperator(data) {
      this.operatorName = data?.name
    },
    handleOk(bvModal) {
      bvModal.preventDefault()
      if (this.loading) {
        return
      }

      this.$refs.assignOperatorForm.validate().then(success => {
        if (success) {
          this.$refs.formConfirmation.confirm()
        }
      })
    },
    submit() {
      this.loading = true
      ServiceSystemRepository.assignOperator(
        { assignedOperatorId: this.data.assignedOperatorId },
        this.data.serviceSystemId,
      )
        .then(response => {
          this.hide()
          this.$emit('success', response)
        })
        .catch(error => {
          if (error.response?.status === 422) {
            this.$refs.assignOperatorForm.setErrors(
                error.response?.data?.validate,
            )
          }
        })
        .then(() => {
          this.loading = false
        })
    },
  },
  setup() {
    const formInput = [...FormInput]

    return {
      formInput,
    }
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
